<template>
  <panel-layout
    id="credit-panel"
    :heading="heading"
    :info="info"
    :loading="!!(transactions && transactions.loading) || loading || false"
    :show-footer="false"
  >
    <o-scroll v-if="customer" class="h-full p-4 flex flex-col">
      <h4 class="mb-3 font-medium text-gray-700 dark:text-gray-200">
        {{ $t('general.transactions') }}
      </h4>
      <o-table
        v-if="transactions"
        class="border rounded"
        :data="transactions"
        :headers="[
          {text: $t('general.type')},
          {text: $t('general.amount')},
          {text: $t('general.date')},
          {text: $t('general.sale')}
        ]"
        :limit="20"
        :tbody-class="{
          tfoot: '',
          tr: 'transition-all duration-200 bg-gray-50 dark:bg-gray-900',
          td: 'py-3 px-4 text-gray-800 text-sm dark:text-gray-100',
          stripe: 'bg-gray-50/50 dark:bg-gray-900'
        }"
        :thead-class="{
          thead: 'border-b',
          tr: 'border-blue-700',
          th: 'font-normal p-4 pb-3 bg-gray-50 text-gray-700 text-sm sticky top-0 dark:bg-gray-900 dark:text-gray-200',
          content: 'flex item-center'
        }"
        striped
      >
        <template #row="{ row, tdClass }">
          <td :class="tdClass">
            {{ row.type ? $t(CustomerCreditTransactionTypeLabels[row.type]) : '-' }}
          </td>
          <td :class="tdClass">
            {{ formatAmount(row.amount) }}
          </td>
          <td :class="tdClass">
            {{ formatDate(row.date) }}
          </td>
          <td :class="tdClass">
            {{ row.order ? row.order.orderNumber : '-' }}

            <o-panel-link
              v-if="row.order"
              :path="`/order/${row.order.idOrder}`"
              tag="o-button"
              size="sm"
              flat
              class="ml-3"
            >
              {{ $t('general.view') }}
            </o-panel-link>
          </td>
        </template>
      </o-table>
    </o-scroll>
  </panel-layout>
</template>
<script setup lang="ts">
// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

import {
  TablePager,
} from '@/_api/lib/pager'
import { CustomerCreditTransactionTypeLabels } from '@/_api/models/customer'

// @ts-ignore
import {
  OPager,
  OTable,
} from '@/components/elements'

const props = defineProps<{ id?: string }>()

const { $api, $currency, $date, $i18n } = useNuxtApp()

const customer = ref<any>(null)
const transactions = ref<any>(new TablePager((page: any) => $api.customer.creditTransactions(customer.value.idCustomer, { page }), 20))
const loading = ref(true)

const heading = computed(() => {
  if (customer.value) {
    return `${$i18n.t('pages.customer.credit.id.creditTransactions')}: ` + customer.value.displayName
  }

  return $i18n.t('pages.customer.credit.id.creditTransactions')
})

const info = computed(() => {
  if (customer.value) {
    return `${$i18n.t('general.balance')}: ` + customer.value.balances.creditLabel
  }

  return ''
})

const formatAmount = (amount: any) => {
  return $currency.format(amount)
}

const formatDate = (date: any) => {
  return $date.format(date * 1000, $date.presets.full)
}

const init = async (idCustomer?: string) => {
  loading.value = true
  try {
    if (idCustomer) {
      customer.value = (await $api.customer.get(idCustomer)).data

      if (transactions.value && customer.value) {
        transactions.value.load()
      }
    }
  } catch (e) {
    console.log(e)
  }
  loading.value = false
}

watch(() => props.id, (id) => init(id), { immediate: true })
</script>
